import { PublicClientApplication } from "@azure/msal-browser";
import { MsalAuthenticationContext } from './MsalAuthenticationContext';
export class MsalAuthenticationContextFactory {
    static createAuthenticationContext(msalConfig, showInteractiveLoginRequestFunction, showInteractiveLogoutRequestFunction) {
        const msalPublicClientApplication = new PublicClientApplication(msalConfig);
        const result = new MsalAuthenticationContext(msalPublicClientApplication, showInteractiveLoginRequestFunction, showInteractiveLogoutRequestFunction);
        return result;
    }
}
